export default __webpack_public_path__ + "static/media/profileIcon.367187f1.svg";